import type { PMIssueComment } from "@/domains/pm/types";

/** Display name of a comment's author — full name, else email, else "Unknown". */
export function getDisplayName(comment: PMIssueComment): string {
  if (!comment.author) return "Unknown";
  const name = `${comment.author.first_name || ""} ${comment.author.last_name || ""}`.trim();
  return name || comment.author.email;
}
